module.exports = __webpack_public_path__ + "img/nointernet2.2ec20837.svg";